module.exports = __webpack_public_path__ + "files/c8bcd6e8409e86d6f4752b2d7cd202d2.png";